// extracted by mini-css-extract-plugin
module.exports = {"StarRatingError":"StarRating_StarRatingError__iYHm_","starRatingError":"StarRating_StarRatingError__iYHm_"};